const cardProduct = {
    state: {
      iccids: sessionStorage.getItem("key_transfer_product"),
    },
    mutations: {
      SET_CACHE_TRANSFER_ICCID:(state,iccids)=>{
        state.iccids = iccids;
        sessionStorage.setItem("key_transfer_product",iccids);
      },
      CLEAR_CACHE_TRANSFER_ICCID:(state)=>{
        state.iccids = undefined;
        sessionStorage.removeItem("key_transfer_product");
      },
    },
    actions: {
        CacheTransferIccids({ commit }, iccids) {
            commit('SET_CACHE_TRANSFER_ICCID', iccids)  
        },
        ClearTransferIccids({ commit }) {
            commit('CLEAR_CACHE_TRANSFER_ICCID')  
        },
    }
  }
  
  export default cardProduct